import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

export default function AboutCta() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="relative w-full overflow-hidden" style={{ background: '#111' }}>
      <div
        className={`relative z-10 px-10 lg:px-20 py-32 transition-all duration-1000 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`}
      >
        <p className="text-[#F8CA9D] text-xs tracking-[0.5em] uppercase mb-10 font-medium">
          &#8212;&nbsp;&nbsp;Ready to build?&nbsp;&nbsp;&#8212;
        </p>
        <h2
          className="boldonse text-white leading-none mb-10"
          style={{ fontSize: 'clamp(52px, 7.5vw, 110px)', lineHeight: 0.9 }}
        >
          LET&apos;S CREATE<br />
          <span style={{ color: '#FA6E4F' }}>SOMETHING</span><br />
          GREAT.
        </h2>
        <div className="flex items-center gap-4 flex-wrap">
          <Link
            to="/contact"
            className="px-10 py-4 rounded-full boldonse text-sm tracking-wider transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
            style={{ background: '#FA6E4F', color: '#fff' }}
          >
            GET IN TOUCH
          </Link>
          <Link
            to="/services"
            className="px-10 py-4 rounded-full boldonse text-sm tracking-wider border-2 border-white/30 text-white hover:border-white hover:bg-white/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            OUR SERVICES
          </Link>
        </div>
      </div>
    </section>
  );
}